import React, {Component, Ref} from "react";
import {_ReactPixi, withPixiApp} from "@inlet/react-pixi";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import withTruncateHitAreaConfiguration from "./configuration/withTruncateHitAreaConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import {actions as layoutssActions} from "../../core/reducers/layoutsStateReducer";
import {isMobile} from "react-device-detect";
import {TIMER} from "../../core/utills";
import {actions as multiplierActions} from "../../gamereducer/multiplierReducer";
import {actions as reelGridActions} from "../../core/reducers/reelgridStateReducer";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class TruncateHitArea extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected truncateHitAreaContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected objName: any;
    protected hit: any;
    protected hitAreaGraphic: any;
    protected horizontalHitAreaGraphic: any;
    protected hitAreaGraphicForMobile: any;
    protected horizontalHitAreaGraphicForMobile: any;
    protected portraitScaling: number = 0.85;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.truncateHitAreaContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));
        this.objName = 1;

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //this method will call after the first rendering for scaling and logo animation looping
    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }

    //this method will initialize object to variables
    initializeObjectInVariable() {
        this.hitAreaGraphic = UIManager.getRef("hitArea_Graphic");
        this.horizontalHitAreaGraphic = UIManager.getRef("horizontalHitArea_Graphic");
        this.hitAreaGraphicForMobile = UIManager.getRef("hitArea_Graphic_mobile");
        this.horizontalHitAreaGraphicForMobile = UIManager.getRef("horizontalHitArea_Graphic_mobile");


    }

    componentDidMount() {
        this.initializeObjectInVariable();
        if (isMobile) {
            this.hitAreaScaling();
        }
        this.bindUI();
    }

    hitAreaScaling() {
        if (window.innerWidth < window.innerHeight) {
            UIManager.getRef("hitArea_Graphic_mobile").scale.set(this.portraitScaling);
            UIManager.getRef("horizontalHitArea_Graphic_mobile").scale.x = this.portraitScaling;
        } else {
            UIManager.getRef("hitArea_Graphic_mobile").scale.set(1);
            UIManager.getRef("horizontalHitArea_Graphic_mobile").scale.set(1);

        }
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
                if (data.layout === true) {
                    this.props.setApplicationLayoutObject(data.name);


                }
            }
        )
    }

    hitAreaActive() {
        this.hitAreaGraphic.interactive = true;
        this.hitAreaGraphic.buttonMode = true;
        this.horizontalHitAreaGraphic.interactive = true;
        this.horizontalHitAreaGraphic.buttonMode = true;
        this.hitAreaGraphic.click = (event: any) => {
            this.props.forceStopSpin();
        }
        this.horizontalHitAreaGraphic.click = (event: any) => {
            this.props.forceStopSpin();
        }
    }

    hitAreaActiveForMobile() {

        this.hitAreaGraphicForMobile.interactive = true;
        this.hitAreaGraphicForMobile.buttonMode = true;
        this.horizontalHitAreaGraphicForMobile.interactive = true;
        this.horizontalHitAreaGraphicForMobile.buttonMode = true;

        this.hitAreaGraphicForMobile.addListener('touchend', (evt: MouseEvent): void => {
            this.props.forceStopSpin();
        })
        this.horizontalHitAreaGraphicForMobile.addListener('touchend', (evt: MouseEvent): void => {
            this.props.forceStopSpin();
        })

    }

    hitAreaDeactiveForMobile() {
        // this.props.setTurboMode(false);
        this.hitAreaGraphicForMobile.interactive = false;
        this.hitAreaGraphicForMobile.buttonMode = false;
        this.horizontalHitAreaGraphicForMobile.interactive = false;
        this.horizontalHitAreaGraphicForMobile.buttonMode = false;
    }

    hitAreaDeactive() {
        //this.props.setTurboMode(false);
        this.hitAreaGraphic.interactive = false;
        this.hitAreaGraphic.buttonMode = false;
        this.horizontalHitAreaGraphic.interactive = false;
        this.horizontalHitAreaGraphic.buttonMode = false;
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode || nextProps.spinStart !== this.props.spinStart) {

            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
                if (isMobile) {
                    this.hitAreaScaling();
                }
            }
            if (nextProps.spinStart) {
                !isMobile ? this.hitAreaActive() : this.hitAreaActiveForMobile();
            }


            return false;

        }
        if (nextProps.allSpinComplete !== this.props.allSpinComplete && nextProps.allSpinComplete) {
            !isMobile ? this.hitAreaDeactive() : this.hitAreaDeactiveForMobile();
            return false;
        }

        return false;
    }


    render() {
        return (
            <UIManager id={"truncateHitAreaContainer"} name={"truncateHitAreaContainer"} type={"Container"}
                       ref={i => this.truncateHitAreaContainer = i} configGame={this.props.configGame}
                       app={this.app}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                                   id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                                   scope={this}/>
                    )
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'MultiplierState' | 'applicationState' | 'reelgridState'>): IStateToProps =>
        ({
            layoutMode: state.applicationState.layoutMode,
            multiplierActive: state.MultiplierState.multiplierActive,
            allSpinComplete: state.reelgridState.allSpinComplete,
            spinStart: state.reelgridState.spinStart,
        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        // setTurboMode: (IsTurboMode: any): any => dispatch(reelGridActions.setTurboMode(IsTurboMode)),
        forceStopSpin: (): any => dispatch(reelGridActions.forceStopSpin()),
    }))(withTruncateHitAreaConfiguration(TruncateHitArea)));
